<template>
  <v-menu>
    <template #activator="{ props }">
      <v-btn
        v-bind="props"
        variant="text"
        class="mode-selector text-none"
        density="compact"
      >
        <v-icon start size="20">{{ currentMode.icon }}</v-icon>
        <span v-if="$vuetify.display.smAndUp">{{ currentMode.label }}</span>
        <v-icon end size="18">mdi-chevron-down</v-icon>
      </v-btn>
    </template>
    <v-list density="compact">
      <v-list-item
        v-for="mode in modes"
        :key="mode.value"
        :active="mode.value === currentModeValue"
        @click="setMode(mode.value)"
      >
        <template #prepend>
          <v-icon size="20">{{ mode.icon }}</v-icon>
        </template>
        <v-list-item-title>{{ mode.label }}</v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script setup>
import { computed } from 'vue';
import { useAppStore } from '@/stores/app';
import { useRouter } from 'vue-router';

const appStore = useAppStore();
const router = useRouter();

const modes = [
  { value: 'schedules', label: 'Schedules', icon: 'mdi-calendar-clock', defaultRoute: 'Update' },
  { value: 'taskSetProfiles', label: 'Task Set Profiles', icon: 'mdi-file-tree-outline', defaultRoute: 'TSPUpdate' }
];

const currentModeValue = computed(() => appStore.appMode || 'schedules');
const currentMode = computed(() => modes.find(m => m.value === currentModeValue.value) || modes[0]);

function setMode(mode) {
  appStore.setAppMode(mode);

  // Navigate to default route for the mode
  const selectedMode = modes.find(m => m.value === mode);
  if (selectedMode) {
    router.push({ name: selectedMode.defaultRoute });
  }
}
</script>

<style scoped>
.mode-selector {
  min-width: 120px;
}
</style>
